const SENSITIVE_PARAMS = new Set(
  [
    'token',
    'oobCode',
    'link_token',
    'email',
    'apiKey',
    'mode',
    'continueUrl',
    'redirect',
    'search',
    'sc_q',
    'shop',
    'hmac',
    'host',
    'code',
    'state',
    'claim',
    'access_token',
    'refresh_token',
    'id_token',
    'password',
    'secret',
    'api_key',
  ].map((p) => p.toLowerCase()),
);

const REDACTED = '[redacted]';
const SHARE_PATH = /(^|\s|\/\/[^/\s]+)\/s\/[^/\s]+/g;
const EMAIL = /[\w.+'-]+(?:@|%40)[\w-]+(?:\.[\w-]+)+/gi;
const CREDENTIAL_IN_TEXT =
  /(claim|token|oobCode|link_token|apiKey|email|hmac|continueUrl)(=|%3D|%253D)[^&\s]*/gi;

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

function scrubQuery(query: string): string {
  return query
    .split('&')
    .map((pair) => {
      const eq = pair.indexOf('=');
      if (eq === -1) return pair;
      const key = pair.slice(0, eq);
      if (SENSITIVE_PARAMS.has(safeDecode(key).toLowerCase())) return `${key}=${REDACTED}`;
      return pair;
    })
    .join('&');
}

function stripEmails(text: string): string {
  return text.replace(EMAIL, '[email]');
}

/** Removes emails and credential-looking `claim=`/`token=` pairs from free text. */
export function scrubText(text: string): string;
export function scrubText(text: string | undefined): string | undefined;
export function scrubText(text: string | undefined): string | undefined {
  if (!text) return text;
  return text
    .replace(CREDENTIAL_IN_TEXT, (_m, key: string, eq: string) => `${key}${eq}${REDACTED}`)
    .replace(EMAIL, '[email]');
}

/**
 * Makes a URL safe to send to analytics or error tracking: drops the fragment,
 * redacts the values of sensitive query params, and strips emails anywhere.
 * Works on absolute and relative URLs; non-sensitive params are kept.
 */
export function scrubUrl(url: string): string;
export function scrubUrl(url: string | undefined): string | undefined;
export function scrubUrl(url: string | undefined): string | undefined {
  if (!url) return url;
  const hash = url.indexOf('#');
  const noFragment = hash === -1 ? url : url.slice(0, hash);
  const q = noFragment.indexOf('?');
  const base = q === -1 ? noFragment : noFragment.slice(0, q);
  const query = q === -1 ? '' : `?${scrubQuery(noFragment.slice(q + 1))}`;
  return stripEmails(`${base.replace(SHARE_PATH, '$1/s/:code')}${query}`);
}
